import { ActiveConfig, WorkflowUserType } from '@finxone-platform/shared/sys-config-types';

export const defaultActiveConfig = {
  activeViewScreen: {
    page: '',
  },
  activeSection: '',
  activeCanvasSubscription: '',
  activeZone: '',
  activeRole: '',
  activeRoleIndex: 0,
  activeUserType: WorkflowUserType.USER,
  activeScreenWidth: 0,
  activeScreenHeight: 0,
  activeTabSelections: {},
} as ActiveConfig;
